/**
 * Croatian Heritage page - scroll reveals and the pleter interlace band.
 * Motion is skipped for reduced-motion users and inside the theme editor.
 */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = !!(window.Shopify && window.Shopify.designMode);

  /* ---------------- pleter interlace ---------------- */

  var P = 200, A = 42, CY = 100, TILE = 1200;

  function y(x, ph) { return CY + A * Math.sin((2 * Math.PI * x) / P + ph); }
  function dy(x, ph) { return A * ((2 * Math.PI) / P) * Math.cos((2 * Math.PI * x) / P + ph); }

  function segment(x0, x1, ph) {
    var n = Math.max(1, Math.round((x1 - x0) / (P / 4)));
    var d = 'M ' + x0.toFixed(1) + ' ' + y(x0, ph).toFixed(1);
    for (var k = 0; k < n; k++) {
      var a = x0 + ((x1 - x0) * k) / n;
      var b = x0 + ((x1 - x0) * (k + 1)) / n;
      var D = (b - a) / 3;
      d +=
        ' C ' + (a + D).toFixed(1) + ' ' + (y(a, ph) + dy(a, ph) * D).toFixed(1) +
        ' ' + (b - D).toFixed(1) + ' ' + (y(b, ph) - dy(b, ph) * D).toFixed(1) +
        ' ' + b.toFixed(1) + ' ' + y(b, ph).toFixed(1);
    }
    return d;
  }

  function drawPlait(svg) {
    if (svg.dataset.cjhDrawn) return;
    svg.dataset.cjhDrawn = '1';
    var ns = 'http://www.w3.org/2000/svg';
    var frag = document.createDocumentFragment();
    var halves = TILE / (P / 2);
    for (var k = 0; k < halves; k++) {
      var x0 = (k * P) / 2;
      var x1 = ((k + 1) * P) / 2;
      for (var j = 0; j < 3; j++) {
        var d = segment(x0, x1, (2 * Math.PI * ((k + j) % 3)) / 3);
        var bg = document.createElementNS(ns, 'path');
        bg.setAttribute('class', 'pb');
        bg.setAttribute('d', d);
        var fg = document.createElementNS(ns, 'path');
        fg.setAttribute('class', 'pf');
        fg.setAttribute('d', d);
        frag.appendChild(bg);
        frag.appendChild(fg);
      }
    }
    svg.appendChild(frag);
  }

  function initPlaits(root) {
    var list = (root || document).querySelectorAll('[data-cjh-plait]');
    for (var i = 0; i < list.length; i++) drawPlait(list[i]);
  }

  /* ---------------- scroll reveals ---------------- */

  function initReveals(root) {
    var items = (root || document).querySelectorAll('[data-cjh-reveal]');
    if (!items.length) return;

    if (reduce || designMode || !('IntersectionObserver' in window)) {
      for (var i = 0; i < items.length; i++) items[i].setAttribute('data-cjh-shown', '');
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.setAttribute('data-cjh-shown', '');
          io.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );

    for (var j = 0; j < items.length; j++) io.observe(items[j]);
  }

  function init(root) {
    initPlaits(root);
    initReveals(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
